import { ReactNode } from 'react';
import Button from '../../../ui/button';
import styles from './styles.module.scss';

interface FloorPopupProps {
  children: ReactNode;
  onCancel: () => void;
  onSelect: () => void;
  isSingle: boolean;
}

const FloorPopup: React.FC<FloorPopupProps> = ({
  children,
  onCancel,
  onSelect,
  isSingle,
}) => (
  <div className={styles.FloorPopup} onClick={(e) => e.stopPropagation()}>
    {children}
    {!isSingle && (
      <div className={styles.btnsContainer}>
        <Button
          color="text"
          type="rounded-10"
          size="sm"
          className={styles.btn}
          // onClick={() => category.onSelect(category)}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          type="rounded-10"
          size="sm"
          className={styles.btn}
          onClick={onSelect}
        >
          Select
        </Button>
      </div>
    )}
  </div>
);

export default FloorPopup;
